import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { toast } from 'sonner';
import { api, formatApiError } from '../../lib/api';
import { useT } from '../../context/LanguageContext';

export const fieldCls = 'w-full px-4 py-3.5 rounded-2xl bg-white/5 border border-white/10 text-white placeholder-white/30 focus:border-[#ff2e2e] focus:outline-none focus:bg-white/10 transition-colors';
export const labelCls = 'block text-xs font-bold text-white/70 mb-1.5 uppercase tracking-wider';

export const ProfileForm = ({ user, onUpdated }) => {
  const { t } = useT();
  const [name, setName] = useState(user.name || '');
  const [email, setEmail] = useState(user.email || '');
  const [username, setUsername] = useState(user.username || '');
  const [phone, setPhone] = useState(user.phone || '');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put('/users/me', { name, email, username: username.trim() || undefined, phone });
      onUpdated(data);
      toast.success(t('Profilen er lagra'));
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="profile-form">
      <div>
        <label className={labelCls}>{t('Namn')}</label>
        <input data-testid="profile-name-input" value={name} onChange={(e) => setName(e.target.value)} className={fieldCls} required minLength={1} />
      </div>
      <div>
        <label className={labelCls}>{t('Brukarnamn')}</label>
        <input data-testid="profile-username-input" value={username} onChange={(e) => setUsername(e.target.value.toLowerCase().replace(/[^a-z0-9._-]/g, ''))} className={fieldCls} minLength={3} maxLength={32} pattern="[a-z0-9._-]{3,32}" placeholder="refuelmedlem" />
        <p className="mt-1 text-xs text-white/40">{t('Du kan logge inn med brukarnamn eller e-post.')}</p>
      </div>
      <div>
        <label className={labelCls}>{t('E-post')}</label>
        <input data-testid="profile-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={fieldCls} required />
        {user.email_placeholder && <p className="mt-1 text-xs text-white/40">{t('Legg inn di eiga e-postadresse for å få passordreset og viktige meldingar.')}</p>}
      </div>
      <div>
        <label className={labelCls}>{t('Telefon')}</label>
        <input data-testid="profile-phone-input" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+47 000 00 000" className={fieldCls} maxLength={30} />
      </div>
      <button type="submit" data-testid="profile-save-button" disabled={saving} className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#ff2e2e] text-black font-bold uppercase tracking-wide hover:bg-[#ff4d4d] transition-colors disabled:opacity-60">
        <Save size={16} /> {saving ? t('Lagrar…') : t('Lagre endringar')}
      </button>
    </form>
  );
};
